import { RowContainerWithScroll } from '@/components/RowContainerWithScroll'
import { Flex, Grid, VStack } from '@sevenrooms/ui-kit/layout'
import type { ThemeSpacing } from '@sevenrooms/ui-kit/theme'
import type { PropsWithChildren, ReactNode } from 'react'

interface ExperiencesContainerProps {
  columnsCount: number
  useHorizontalScroll?: boolean
  scrollRightMargin?: ThemeSpacing
  label?: ReactNode
}

export function ExperiencesContainer({
  columnsCount,
  useHorizontalScroll,
  label,
  scrollRightMargin,
  children,
}: PropsWithChildren<ExperiencesContainerProps>) {
  if (useHorizontalScroll) {
    return (
      <RowContainerWithScroll
        data-test="sr-reservation-experiences"
        spacing="m"
        childWidth="330px"
        label={label}
        marginRight={scrollRightMargin}
      >
        {children}
      </RowContainerWithScroll>
    )
  }
  return (
    <VStack spacing="m">
      {label && <Flex>{label}</Flex>}
      <Grid
        data-test="sr-reservation-experiences"
        gap="m"
        gridTemplateColumns={`repeat(${columnsCount}, minmax(0, ${1 / columnsCount}fr))`}
        alignItems="stretch"
      >
        {children}
      </Grid>
    </VStack>
  )
}
